import axios from 'axios';
import { toast } from 'react-toastify';

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // Handle 401 error (unauthorized)
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      toast.error("Session expired. Logging out now...")
      setTimeout(() => {
        window.location.href = "/" // Redirect to the login page after 1 second
      }, 1000)
    }
    return Promise.reject(error)
  },
)

let config = {
    headers: {
        "api-key" : process.env.REACT_APP_KEY,
        "Content-Type": "application/json",
    }
}
let fileconfig = {
    headers: {
        "api-key" : process.env.REACT_APP_KEY,
        "Content-Type": "multipart/form-data",
    }
}

// API Axios Get Call.
export const getAPICall = (url, data) => {
    return axios.get(url, data, config);
}

// API Axios Post Call.
export const postAPICall = (url, data) => {
    return axios.post(url, data, config);
}

// API Axios Post Call.
export const postAPICall2 = (url, data) => {
    return axios.post(url, data, fileconfig);
}

// API Axios Put Call.
export const putAPICall = (url, data) => {
    return axios.put(url, data, config);
}

// API Axios Delete Call.
export const deleteAPICall = (url) => {
    return axios.delete(url,config);
}

export const getAPICallGoogle = (url) => {
    return axios.get(url);
}